export default __webpack_public_path__ + "static/media/Illustration_1.e7636914.svg";